module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('div', {
    staticClass: "isotopeGrid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "backbar_wrapper"
  }, [_c('div', {
    staticClass: "backbar"
  }, [_c('router-link', {
    attrs: {
      "to": '/preventiontips/tips'
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/icon-chevron.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("返回")])])], 1)])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          預防一般昆蟲小貼士\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          您的第一道防線\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('h1', [_vm._v("屋內")]), _vm._v(" "), _c('p', [_vm._v("昆蟲需要食物、水、溫暖和黑暗的空間讓它們隱藏，如果不將家居保持乾淨就有機會被昆蟲入侵。請細看以下防止預防蟲入侵的小貼士：")]), _vm._v(" "), _c('h1', [_vm._v("廚房")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。")]), _vm._v(" "), _c('li', [_vm._v("螞蟻和曱甴往往會聚集在櫃和爐子下方，因此請定期清潔該地方，確保沒有水和碎屑。")]), _vm._v(" "), _c('li', [_vm._v("雪櫃頂部和底部都很溫暖，會吸引昆蟲。所以，請定期清潔這些地方， 尤其要掃走食物碎屑和抹走污跡。")]), _vm._v(" "), _c('li', [_vm._v("因為螞蟻和曱甴會被食物吸引，請將食物存放在玻璃、塑料或充分密封的容器中，以防止昆蟲進入。")]), _vm._v(" "), _c('li', [_vm._v("螞蟻和曱甴傾向於有水源的地方附近聚集和隱藏，所以家裡滴漏的水槽會吸引它們。為防止昆蟲進入，請立刻修理和抹乾這些區域。")]), _vm._v(" "), _c('li', [_vm._v("所有抽屜，橫架和櫥櫃應排列整齊，如有損壞，請盡快修理，以確保曱甴不會有隱藏的地方。如有使用膠墊或紙墊，請保持平坦，以免昆蟲隱藏在墊下。")])]), _vm._v(" "), _c('h1', [_vm._v("浴室")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。")]), _vm._v(" "), _c('li', [_vm._v("螞蟻和曱甴喜愛潮濕環境，所以應定期檢查潮濕的地方，如水槽的上方和下方、廁所後面和浴缸附近有否洩漏。 如有裂縫應立刻密封。")]), _vm._v(" "), _c('li', [_vm._v("請將濕毛巾和牙刷從抽屜和櫃中取出，以免吸引昆蟲。")])]), _vm._v(" "), _c('h1', [_vm._v("客廳")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("螞蟻和曱甴喜歡溫暖的地方，可能會聚集在電視機後方或其他電子產品之間。請定期檢查這些地方。")]), _vm._v(" "), _c('li', [_vm._v("沙發和椅子附近可能有食物碎屑。請保持這些區域乾淨，檢查是否有昆蟲出沒。")]), _vm._v(" "), _c('li', [_vm._v("因為昆蟲經常藏在木材中，所以請檢查所有木材後才帶回家中。")])]), _vm._v(" "), _c('h1', [_vm._v("其他地方")]), _vm._v(" "), _c('p', [_vm._v("\n          您知道幾項簡單的預防措施就可以防止昆蟲的入侵嗎？"), _c('br'), _vm._v("\n          預防勝於治療，防止昆蟲入侵的每一步都很重要。\n        ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("將所有食物存放在密閉的容器中，避免螞蟻和曱甴進食。")]), _vm._v(" "), _c('li', [_vm._v("請洗淨用完的碗碟及杯。")]), _vm._v(" "), _c('li', [_vm._v("使用矽膠把所有外部開口和裂縫密封。")]), _vm._v(" "), _c('li', [_vm._v("經常清潔枱面及櫃面以除去食物殘渣。")]), _vm._v(" "), _c('li', [_vm._v("請盡快洗淨水槽中骯髒的碗碟和器具。")]), _vm._v(" "), _c('li', [_vm._v("請避免讓植物接觸房屋/建築物的外部。")]), _vm._v(" "), _c('li', [_vm._v("請定期清理廚房以減少隱藏的食物殘渣和肉眼看不見的碎屑。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80633158","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PTipsTipsGeneral.vue
// module id = 243
// module chunks = 0